// extracted by css-extract-rspack-plugin
var _1 = "amounts__KBUNn";
var _2 = "amounts__discount-price__wlxf1";
var _3 = "amounts__list-price__BHamj";
var _4 = "container__kS4Hk";
var _5 = "detail__DTJgL";
var _6 = "disclaimer-wrapper__b3FYK";
var _7 = "header__ZNFb6";
var _8 = "package-type-label__LhjiC";
var _9 = "price-per-pr__iYjxv";
var _a = "pricing__ka3vl";
var _b = "quantity-widget-wrapper__KBKMe";
var _c = "review-info__hUswe";
var _d = "total__XqGZ8";
var _e = "total__label__BlhY4";
var _f = "total__price-wrapper__OOQaM";
var _10 = "total__price-wrapper__price__eKhd4";
export { _1 as "amounts", _2 as "amounts__discount-price", _3 as "amounts__list-price", _4 as "container", _5 as "detail", _6 as "disclaimer-wrapper", _7 as "header", _8 as "package-type-label", _9 as "price-per-pr", _a as "pricing", _b as "quantity-widget-wrapper", _c as "review-info", _d as "total", _e as "total__label", _f as "total__price-wrapper", _10 as "total__price-wrapper__price" }
export default { "amounts": _1, "amounts__discount-price": _2, "amounts__list-price": _3, "container": _4, "detail": _5, "disclaimer-wrapper": _6, "header": _7, "package-type-label": _8, "price-per-pr": _9, "pricing": _a, "quantity-widget-wrapper": _b, "review-info": _c, "total": _d, "total__label": _e, "total__price-wrapper": _f, "total__price-wrapper__price": _10 }
